module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "front"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("STUDIES IN EARLY AMERICAN ECONOMY AND SOCIETY FROM THE LIBRARY COMPANY OF PHILADELPHIA")]), _vm._v(" "), _c('p', {
    staticClass: "front"
  }, [_vm._v("Cathy Matson, "), _c('em', [_vm._v("Series Editor")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fa306ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Front.vue
// module id = 60
// module chunks = 0